import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function Policies() {
  const navigate = useNavigate();
  const [showContactModal, setShowContactModal] = useState(false);

  return (
    <div>
      <div className="card" style={{ textAlign: 'center', padding: '60px 24px', marginBottom: '30px', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: 'white' }}>
        <div style={{ fontSize: '48px', marginBottom: '15px' }}>📋</div>
        <h1 style={{ fontSize: '48px', marginBottom: '20px' }}>
          Policies
        </h1>
        <p style={{ fontSize: '20px', opacity: '0.95', maxWidth: '800px', margin: '0 auto' }}>
          Our commitment to transparency and fairness
        </p>
      </div>

      {/* Refund Policy */}
      <div className="card" style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '32px', marginBottom: '20px', color: '#4f46e5', display: 'flex', alignItems: 'center', gap: '12px' }}>
          <span>💰</span>
          <span>Refund Policy</span>
        </h2>
        
        <div style={{ fontSize: '18px', lineHeight: '1.8', color: '#666' }}>
          <h3 style={{ fontSize: '24px', marginTop: '25px', marginBottom: '15px', color: '#333' }}>
            Free Practice Tests
          </h3>
          <p style={{ marginBottom: '20px' }}>
            Our Free plan includes 12 full-length practice tests and 4 topic-based trial tests at <strong>no charge</strong>. 
            No refunds are applicable as there are no charges for the Free plan.
          </p>

          <h3 style={{ fontSize: '24px', marginTop: '25px', marginBottom: '15px', color: '#333' }}>
            Essential Bundle ($75) & Premium Bundle ($100)
          </h3>
          <p style={{ marginBottom: '15px' }}>
            Paid bundles provide access until the end of the current exam season (May 2027). The following refund policy applies:
          </p>
          <ul style={{ marginLeft: '25px', marginBottom: '20px' }}>
            <li style={{ marginBottom: '12px' }}>
              <strong>7-Day Money-Back Guarantee:</strong> Full refund available within 7 days of purchase if you're not satisfied
            </li>
            <li style={{ marginBottom: '12px' }}>
              <strong>Partial Refunds:</strong> After 7 days, refunds may be considered on a case-by-case basis
            </li>
            <li style={{ marginBottom: '12px' }}>
              <strong>No Refund After Completion:</strong> Once you've completed more than 80% of a premium bundle, refunds are not available
            </li>
          </ul>

          <h3 style={{ fontSize: '24px', marginTop: '25px', marginBottom: '15px', color: '#333' }}>
            How to Request a Refund
          </h3>
          <p style={{ marginBottom: '15px' }}>
            To request a refund for premium content:
          </p>
          <ol style={{ marginLeft: '25px', marginBottom: '20px' }}>
            <li style={{ marginBottom: '12px' }}>Email us at <a href="mailto:prepsmart.help@gmail.com" style={{ color: '#4f46e5', fontWeight: '600' }}>prepsmart.help@gmail.com</a></li>
            <li style={{ marginBottom: '12px' }}>Include your order number and reason for refund</li>
            <li style={{ marginBottom: '12px' }}>We'll process your request within 2-3 business days</li>
            <li style={{ marginBottom: '12px' }}>Refunds will be issued to your original payment method within 5-7 business days</li>
          </ol>
        </div>
      </div>

      {/* Privacy Policy */}
      <div className="card" style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '32px', marginBottom: '20px', color: '#4f46e5', display: 'flex', alignItems: 'center', gap: '12px' }}>
          <span>🔒</span>
          <span>Privacy & Data Protection Policy</span>
        </h2>
        
        <div style={{ fontSize: '18px', lineHeight: '1.8', color: '#666' }}>
          <p style={{ marginBottom: '20px', fontWeight: '600', color: '#333' }}>
            PrepSmart is committed to protecting the privacy and personal information of students and families in accordance with 
            NSW privacy laws and educational standards.
          </p>

          <h3 style={{ fontSize: '24px', marginTop: '25px', marginBottom: '15px', color: '#333' }}>
            Information We Collect
          </h3>
          <p style={{ marginBottom: '20px' }}>
            We collect minimal information necessary to provide our educational services:
          </p>
          <ul style={{ marginLeft: '25px', marginBottom: '20px' }}>
            <li style={{ marginBottom: '12px' }}>Name and email address (for account creation and authentication)</li>
            <li style={{ marginBottom: '12px' }}>Test results and progress data (to track improvement and provide feedback)</li>
            <li style={{ marginBottom: '12px' }}>Usage data (to improve platform functionality)</li>
            <li style={{ marginBottom: '12px' }}>We do <strong>not</strong> store payment card details — all payments are securely processed by Stripe</li>
          </ul>

          <h3 style={{ fontSize: '24px', marginTop: '25px', marginBottom: '15px', color: '#333' }}>
            How We Use Your Information
          </h3>
          <ul style={{ marginLeft: '25px', marginBottom: '20px' }}>
            <li style={{ marginBottom: '12px' }}>To provide and improve our educational services</li>
            <li style={{ marginBottom: '12px' }}>To track student progress and provide personalized feedback</li>
            <li style={{ marginBottom: '12px' }}>To communicate important updates about the platform</li>
            <li style={{ marginBottom: '12px' }}>To ensure platform security and prevent misuse</li>
            <li style={{ marginBottom: '12px' }}><strong>We never sell, rent, or share personal information with third parties for marketing purposes</strong></li>
          </ul>

          <h3 style={{ fontSize: '24px', marginTop: '25px', marginBottom: '15px', color: '#333' }}>
            Data Security & Protection
          </h3>
          <p style={{ marginBottom: '20px' }}>
            We implement industry-standard security measures to protect student data:
          </p>
          <ul style={{ marginLeft: '25px', marginBottom: '20px' }}>
            <li style={{ marginBottom: '12px' }}>AWS Cognito authentication with encrypted password storage</li>
            <li style={{ marginBottom: '12px' }}>Encrypted data transmission (HTTPS/SSL)</li>
            <li style={{ marginBottom: '12px' }}>Secure cloud storage with AWS DynamoDB</li>
            <li style={{ marginBottom: '12px' }}>Regular security audits and updates</li>
            <li style={{ marginBottom: '12px' }}>Access controls limiting who can view student data</li>
          </ul>

          <h3 style={{ fontSize: '24px', marginTop: '25px', marginBottom: '15px', color: '#333' }}>
            Parental Rights & Access
          </h3>
          <p style={{ marginBottom: '20px' }}>
            Parents and guardians have the right to:
          </p>
          <ul style={{ marginLeft: '25px', marginBottom: '20px' }}>
            <li style={{ marginBottom: '12px' }}>Access their child's account and progress data</li>
            <li style={{ marginBottom: '12px' }}>Request correction of inaccurate information</li>
            <li style={{ marginBottom: '12px' }}>Request deletion of their child's account and data</li>
            <li style={{ marginBottom: '12px' }}>Withdraw consent for data collection at any time</li>
          </ul>
          <p style={{ marginBottom: '20px' }}>
            To exercise these rights, contact us at <a href="mailto:prepsmart.help@gmail.com" style={{ color: '#4f46e5', fontWeight: '600' }}>prepsmart.help@gmail.com</a>
          </p>

          <h3 style={{ fontSize: '24px', marginTop: '25px', marginBottom: '15px', color: '#333' }}>
            Data Retention
          </h3>
          <p style={{ marginBottom: '20px' }}>
            We retain student data only as long as necessary to provide our services. Account data and test results 
            are retained while the account is active. Upon account deletion, all personal data is permanently removed 
            within 30 days.
          </p>
        </div>
      </div>

      {/* Child Safety & Online Protection */}
      <div className="card" style={{ marginBottom: '30px', background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)', color: 'white' }}>
        <h2 style={{ fontSize: '32px', marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '12px' }}>
          <span>🛡️</span>
          <span>Child Safety & Online Protection</span>
        </h2>
        
        <div style={{ fontSize: '18px', lineHeight: '1.8' }}>
          <p style={{ marginBottom: '20px', fontWeight: '600', opacity: '0.95' }}>
            PrepSmart is committed to providing a safe online learning environment for all students.
          </p>

          <h3 style={{ fontSize: '24px', marginTop: '25px', marginBottom: '15px' }}>
            Safe Learning Environment
          </h3>
          <ul style={{ marginLeft: '25px', marginBottom: '20px', opacity: '0.95' }}>
            <li style={{ marginBottom: '12px' }}>No social features, chat, or communication between users</li>
            <li style={{ marginBottom: '12px' }}>No advertising or third-party content</li>
            <li style={{ marginBottom: '12px' }}>Age-appropriate educational content only</li>
            <li style={{ marginBottom: '12px' }}>Feedback is educational and constructive, never critical or harmful</li>
            <li style={{ marginBottom: '12px' }}>Platform monitored for inappropriate use</li>
          </ul>

          <h3 style={{ fontSize: '24px', marginTop: '25px', marginBottom: '15px' }}>
            Cyber Safety Guidelines
          </h3>
          <ul style={{ marginLeft: '25px', marginBottom: '20px', opacity: '0.95' }}>
            <li style={{ marginBottom: '12px' }}>Students should never share their login credentials</li>
            <li style={{ marginBottom: '12px' }}>Parents are encouraged to supervise younger students</li>
            <li style={{ marginBottom: '12px' }}>Report any concerns immediately to prepsmart.help@gmail.com</li>
            <li style={{ marginBottom: '12px' }}>We comply with eSafety Commissioner guidelines</li>
          </ul>

          <h3 style={{ fontSize: '24px', marginTop: '25px', marginBottom: '15px' }}>
            Reporting Concerns
          </h3>
          <p style={{ marginBottom: '15px', opacity: '0.95' }}>
            If you have any concerns about child safety or inappropriate content:
          </p>
          <ul style={{ marginLeft: '25px', marginBottom: '20px', opacity: '0.95' }}>
            <li style={{ marginBottom: '12px' }}>Email us immediately at prepsmart.help@gmail.com</li>
            <li style={{ marginBottom: '12px' }}>Contact the eSafety Commissioner: <a href="https://www.esafety.gov.au" style={{ color: 'white', fontWeight: '600', textDecoration: 'underline' }}>esafety.gov.au</a></li>
          </ul>
        </div>
      </div>

      {/* Terms of Service */}
      <div className="card" style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '32px', marginBottom: '20px', color: '#4f46e5', display: 'flex', alignItems: 'center', gap: '12px' }}>
          <span>📜</span>
          <span>Terms of Service</span>
        </h2>
        
        <div style={{ fontSize: '18px', lineHeight: '1.8', color: '#666' }}>
          <h3 style={{ fontSize: '24px', marginTop: '25px', marginBottom: '15px', color: '#333' }}>
            Acceptable Use
          </h3>
          <p style={{ marginBottom: '20px' }}>
            By using PrepSmart, you agree to:
          </p>
          <ul style={{ marginLeft: '25px', marginBottom: '20px' }}>
            <li style={{ marginBottom: '12px' }}>Use the platform for personal educational purposes only</li>
            <li style={{ marginBottom: '12px' }}>Not share your account credentials with others</li>
            <li style={{ marginBottom: '12px' }}>Not attempt to copy, redistribute, or resell our content</li>
            <li style={{ marginBottom: '12px' }}>Provide accurate information during registration</li>
          </ul>

          <h3 style={{ fontSize: '24px', marginTop: '25px', marginBottom: '15px', color: '#333' }}>
            Content Ownership
          </h3>
          <p style={{ marginBottom: '20px' }}>
            All practice tests, questions, and educational materials on PrepSmart are our intellectual property. 
            Unauthorized copying or distribution is prohibited.
          </p>

          <h3 style={{ fontSize: '24px', marginTop: '25px', marginBottom: '15px', color: '#333' }}>
            Account Termination
          </h3>
          <p style={{ marginBottom: '20px' }}>
            We reserve the right to terminate accounts that violate our terms of service or engage in fraudulent activity.
          </p>

          <h3 style={{ fontSize: '24px', marginTop: '25px', marginBottom: '15px', color: '#333' }}>
            Paid Access & Expiry
          </h3>
          <p style={{ marginBottom: '20px' }}>
            Paid bundles (Essential and Premium) provide access until the end of the current exam season (May of the exam year selected at registration), 
            regardless of when the purchase is made. Access is for a single student account and is non-transferable. 
            Account credentials must not be shared with others.
          </p>

          <h3 style={{ fontSize: '24px', marginTop: '25px', marginBottom: '15px', color: '#333' }}>
            Changes to Terms & Content
          </h3>
          <p style={{ marginBottom: '20px' }}>
            PrepSmart reserves the right to modify, update, or discontinue any part of the platform, including pricing, 
            features, content, and these terms, at any time without prior notice. Continued use of the platform after 
            changes constitutes acceptance of the updated terms. We recommend reviewing this page periodically.
          </p>
        </div>
      </div>

      {/* Contact Section */}
      <div className="card" style={{ textAlign: 'center', padding: '40px 24px', background: '#f0f9ff' }}>
        <h2 style={{ fontSize: '28px', marginBottom: '15px', color: '#4f46e5' }}>Questions About Our Policies?</h2>
        <p style={{ fontSize: '16px', color: '#666', marginBottom: '25px' }}>
          We're here to help clarify any concerns you may have.
        </p>
        <button 
          className="btn-primary"
          onClick={() => setShowContactModal(true)}
          style={{ padding: '14px 32px', fontSize: '18px' }}
        >
          📧 Contact Support
        </button>
      </div>

      {/* Contact Modal */}
      {showContactModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.6)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 10000,
          backdropFilter: 'blur(4px)'
        }}
        onClick={() => setShowContactModal(false)}
        >
          <div style={{
            background: 'white',
            borderRadius: '16px',
            padding: '40px',
            maxWidth: '500px',
            width: '90%',
            boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
          }}
          onClick={(e) => e.stopPropagation()}
          >
            <div style={{ textAlign: 'center', marginBottom: '30px' }}>
              <div style={{ fontSize: '60px', marginBottom: '15px' }}>📧</div>
              <h2 style={{ fontSize: '28px', fontWeight: 'bold', color: '#1f2937', marginBottom: '10px' }}>
                Contact Support
              </h2>
              <p style={{ fontSize: '16px', color: '#6b7280' }}>
                Choose how you'd like to reach us
              </p>
            </div>

            <div style={{ marginBottom: '25px' }}>
              <button
                onClick={() => window.location.href = 'mailto:PrepSmartHelp <prepsmart.help@gmail.com>'}
                style={{
                  width: '100%',
                  padding: '16px',
                  background: '#4f46e5',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  marginBottom: '12px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '10px'
                }}
              >
                <span style={{ fontSize: '20px' }}>✉️</span>
                Send Email to prepsmart.help@gmail.com
              </button>

              <button
                onClick={() => {
                  setShowContactModal(false);
                  navigate('/about');
                }}
                style={{
                  width: '100%',
                  padding: '16px',
                  background: '#10b981',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '10px'
                }}
              >
                <span style={{ fontSize: '20px' }}>💬</span>
                Send Message via Contact Form (About Page)
              </button>
            </div>

            <button
              onClick={() => setShowContactModal(false)}
              style={{
                width: '100%',
                padding: '12px',
                background: '#f3f4f6',
                color: '#6b7280',
                border: 'none',
                borderRadius: '8px',
                fontSize: '14px',
                fontWeight: '600',
                cursor: 'pointer'
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Policies;
